import { IconButton, Tooltip } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { DataCellProps } from '../types';

const MembersV2ExpandToggleCell = ({ member, _customRowProps }: DataCellProps) => {
  const { expandedIds, onToggleExpand } = _customRowProps;
  const isExpanded = expandedIds?.has(member.id);

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    onToggleExpand?.(member.id);
  };

  return (
    <Tooltip title={isExpanded ? 'Collapse' : 'Expand'}>
      <span>
        <IconButton size="small" onClick={handleClick}>
          {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default MembersV2ExpandToggleCell;
